var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSurvey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48.07,
    height: 34.097,
    viewBox: "0 0 48.07 34.097",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_1517",
    "data-name": "Rechteck 1517",
    width: 46.07,
    height: 32.097,
    fill: "none",
    stroke: "#707070",
    strokeWidth: 2
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3142",
    "data-name": "Gruppe 3142",
    transform: "translate(-69 -78.514)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3810",
    "data-name": "Pfad 3810",
    d: "M244.57,70.779H247V93.624H227.517V70.779h2.141",
    transform: "translate(-144.715 12.717)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3811",
    "data-name": "Pfad 3811",
    d: "M332.2,12.322a2.293,2.293,0,0,0-4.488,0h-1.972v3.015h8.431V12.322Z",
    transform: "translate(-237.413 69.604)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_334",
    "data-name": "Ellipse 334",
    cx: 1.158,
    cy: 1.158,
    r: 1.158,
    transform: "translate(85.399 92.112) rotate(-76.717)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_335",
    "data-name": "Ellipse 335",
    cx: 1.158,
    cy: 1.158,
    r: 1.158,
    transform: "translate(85.399 96.847) rotate(-76.717)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_336",
    "data-name": "Ellipse 336",
    cx: 1.158,
    cy: 1.158,
    r: 1.158,
    transform: "translate(85.634 99.563)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_363",
    "data-name": "Linie 363",
    x2: 8.354,
    transform: "translate(89.497 91.413)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_365",
    "data-name": "Linie 365",
    x2: 8.354,
    transform: "translate(89.497 96.148)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_367",
    "data-name": "Linie 367",
    x2: 8.354,
    transform: "translate(89.497 100.884)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSurvey);
export default __webpack_public_path__ + "static/media/icon_survey.f2219de7ee6ae4bc180aab126e5cd947.svg";
export { ForwardRef as ReactComponent };